import React, { useState } from "react";
import { Button } from "react-bootstrap";

function Counter(props) {
	return (
		<>
			<div className="counter">
				<Button
					variant="info"
					className="mx-1 d-inline-block"
					onClick={props.decrement}
				>
					-
				</Button>
				{props.count}
				<Button
					variant="info"
					className="mx-1 d-inline-block"
					onClick={props.increment}
				>
					+
				</Button>
			</div>
		</>
	);
}

export default Counter;
